import { Injectable } from "@angular/core";
import { ActivatedRouteModel } from '@modules/common/models/activated-route-model';

@Injectable({
    providedIn: 'root'
})
export class ReplaceRouteParameterService {
    public replaceRouteParameter(args: { route: ActivatedRouteModel, paramName: string, paramValue: string, leaveOutEmptyParameter?: boolean }): string[] {
        const result: string[] = [];
        for (let i = 0; i < args.route.urlWithParameterPlaceholders.length; i++) {
            if (args.route.urlWithParameterPlaceholders[i].startsWith(':')) {
                if (args.paramName == args.route.urlWithParameterPlaceholders[i].substring(1)) {
                    if (args.paramValue || !args.leaveOutEmptyParameter) {
                        result.push(args.paramValue);
                    }
                } else {
                    result.push(args.route.params[args.route.urlWithParameterPlaceholders[i].substring(1)]);
                }
            } else {
                result.push(args.route.urlWithParameterPlaceholders[i]);
            }
        }

        return result;
    }
}
